import service from '@/axios/axios';
import app from '@/main';
import url from '@/axios/url';
import { Message } from 'element-ui';
import {goLogin} from '@/utils/judge';

let newoptions = {};

let isRefreshing = true;

let subscribers = [];

function refreshTokenRequst() {
  service
    .request({
      url: `${url().adminUrl}admin/token/refresh`,
      method: 'POST',
    })
    .then((response) => {
      if (response.data.success) {
        if (response.data.result === null) {
          app.$store.dispatch('Logout').then((res) => {
            setTimeout(() => {
              // window.location.href = `/home/login?redirect=${app._route.path}`;
              goLogin()
            });
          });
        } else {
          // app.$store.commit("SET_TOKEN", response.data.result);
          onAccessTokenFetched();
          isRefreshing = true;
        }
      }
    });
}

function onAccessTokenFetched() {
  subscribers.forEach((callback) => {
    callback();
  });
  subscribers = [];
}

function addSubscriber(callback) {
  subscribers.push(callback);
}

function checkStatus(response) {
  if (response && response.status === 426) {
  //   // 刷新token的函数,这需要添加一个开关，防止重复请求
  //   if (isRefreshing) {
  //     refreshTokenRequst();
  //   }
  //   isRefreshing = false;
  //   // 这个Promise函数很关键
  //   const retryOriginalRequest = new Promise((resolve) => {
  //     addSubscriber(() => {
  //       resolve(request(newoptions));
  //     });
  //   });
  //   return retryOriginalRequest;
    app.$store.dispatch('Logout').then((res) => {
      setTimeout(() => {
        // window.location.href = `/home/login?redirect=${app._route.path}`;
        goLogin()
      });
    });
  }
  if (response && !response.data.success) {
    // 去除返回值为流的情况
    const contentType = response.headers['content-type'];
    const interceptors = [
      "application/octet-stream",
      "application/vnd.ms-excel;charset=utf-8",
      "application/octet-stream;charset=UTF-8",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ];
    if (interceptors.includes(contentType)) {
      return response;
    }
    const { message } = response.data;
    Message.error({
      message,
    });
  } else if (response.data.success) {
    if (response.data.code === 408) {
      Message.error({
        message: '请求超时',
      });
      return Promise.reject(response);
    }
    return response;
  } else {
    const message = response.data.message || '请求出错';
    Message.error({
      message,
    });
  }
}

export default function request(options = {}) {
  newoptions = options;
  return service
    .request(options)
    .then(checkStatus)
    .catch((error) => Promise.reject(error));
}
